<template>
  <footer class="dark">
    <div class="body-width">
      <div v-if="footerInfo.dataList" class="copyright">
        <div
          v-for="rowData in footerInfo.dataList"
          :key="rowData.rowId"
          class="footer-text"
        >
          <span v-for="itemData in rowData.itemList" :key="itemData.id">
            <span class="m-r-2">{{ itemData.label }}</span>

            <span
              v-if="
                itemData.children &&
                itemData.children.length === 0 &&
                !itemData.hyperlink
              "
              class="m-r-16"
            >
              {{ itemData.value }}
            </span>

            <span
              v-if="
                itemData.children &&
                itemData.children.length === 0 &&
                itemData.hyperlink
              "
              class="link-item m-r-16"
              @click="toPlatform({ url: itemData.hyperlink })"
            >
              {{ itemData.value }}
            </span>

            <span v-if="itemData.children && itemData.children.length > 0">
              <span
                v-for="childrenData in itemData.children"
                :key="childrenData.id"
              >
                <span v-if="!childrenData.hyperlink" class="m-r-16">
                  {{ childrenData.value }}
                </span>
                <span
                  v-if="childrenData.hyperlink"
                  class="link-item m-r-16"
                  @click="toPlatform({ url: childrenData.hyperlink })"
                >
                  {{ childrenData.value }}
                </span>
                <span v-if="childrenData.isSeparated" class="m-r-16">|</span>
              </span>
            </span>

            <span
              v-if="
                itemData.children &&
                itemData.isSeparated &&
                itemData.children.length === 0
              "
              class="m-r-20"
            >
              |
            </span>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TenantFooter',

  computed: {
    ...mapState('system', ['platformConfig']),

    footerInfo() {
      return this.platformConfig?.footer || {}
    }
  },

  methods: {
    ...mapActions('system', ['toPlatform'])
  }
}
</script>

<style scoped lang="scss">
footer {
  &.dark {
    padding: 32px 0;
    color: $text-third-color;
    background-color: $text-color;
    text-align: center;

    .copyright {
      ::v-deep .text-type--primary {
        color: $primary-second-color !important;
      }
    }
  }

  // 版权信息
  .copyright {
    font-size: 14px;
    line-height: 18px;

    .button-component.small-size {
      font-size: 14px;
    }

    div + div {
      margin-top: 16px;
    }
  }
}
</style>
